// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.LogoPlaid = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.LogoPlaid = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var LogoPlaid = _exports.LogoPlaid = function LogoPlaid(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.41572 2L3.41847 3.28085L2.04116 8.21318L3.77181 9.94693L2.01953 11.6524L3.31752 16.6059L8.29314 17.9717L10.0454 16.2663L11.7689 18L16.7661 16.7192L18.1434 11.7868L16.42 10.0531L18.1723 8.34763L16.8743 3.39407L11.8987 2.02831L10.1464 3.73375L8.41572 2ZM5.35103 4.2291L7.98306 3.54976L9.13683 4.71031L7.45666 6.34498L5.35103 4.2291ZM11.1271 4.73154L12.2953 3.59222L14.9129 4.31402L12.7712 6.40159C12.7784 6.39452 11.1271 4.73154 11.1271 4.73154ZM3.62038 7.80982L4.3487 5.21274L6.45432 7.32862L4.77415 8.96329L3.62038 7.80982ZM13.7663 7.3923L15.908 5.30473L16.593 7.91597L15.4249 9.05529C15.4176 9.05529 13.7663 7.3923 13.7663 7.3923ZM8.44457 7.34984L10.1247 5.71517L11.7761 7.37815L10.0959 9.01283L8.44457 7.34984ZM5.76206 9.96108L7.44223 8.32641L9.09356 9.98939L7.41339 11.6241L5.76206 9.96108ZM11.0838 10.0035L12.764 8.36887L14.4153 10.0318L12.7351 11.6665C12.7351 11.6736 11.0838 10.0035 11.0838 10.0035ZM3.59154 12.084L4.75973 10.9447L6.41106 12.6077L4.27659 14.6953C4.26938 14.6953 3.59154 12.084 3.59154 12.084ZM8.4013 12.6218L10.0815 10.9872L11.7328 12.6502L10.0526 14.2848L8.4013 12.6218ZM13.7231 12.6643L15.4032 11.0296L16.557 12.1902L15.8359 14.7873C15.8287 14.7873 13.7231 12.6643 13.7231 12.6643ZM5.25729 15.686L7.39176 13.5984L9.04309 15.2614L7.8749 16.4007L5.25729 15.686ZM11.0405 15.2826L12.7207 13.6479L14.8263 15.7638L12.1943 16.4432L11.0405 15.2826Z",
      fill: "currentColor"
    }));
  };
});
